import { combineReducers } from "redux";
import auth from "./auth";
import equipments from "./equipmentOrders";
import jobs from "./jobs";
import materialOwners from "./materialOwners";
import progress from "./progress";
import records from "./records";
import tools from "./tools";
import vendors from "./vendors";
import notifications from "./notifications";

export default combineReducers({
  auth,
  records,
  vendors,
  jobs,
  materialOwners,
  equipments,
  progress,
  tools,
  notifications
});
